import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../header/Header";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";

function Layout() {
  return (
    <div className="min-h-screen scrollbar-custom flex flex-col w-full relative overflow-hidden">
      <Header />
      <Navbar />
      <main className="pt-[136px] sm:pt-[100px] flex-1 bg-gray-100 w-full mb-7">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
